/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



// Paste Disable Of Intails

$(document).ready(function() {


 const myInput = document.getElementById('custom-test-input');
 myInput.onpaste = e => e.preventDefault();

 


});  

//infinite scroll pagination
// jQuery(document).ready(function(){

//   $('footer').attr('id', "footer");

//   if ('IntersectionObserver' in window) {
//     const myDiv = document.querySelector('#footer');
//     const observer = new IntersectionObserver((entries, observer) => {
//       entries.forEach(entry => {
//         if (entry.intersectionRatio > 0) {
//           // The div is fully visible in the viewport
//           var result = loadmoreFuntion();
  
//           if(!result){
//             observer.unobserve(entry.target); // Stop observing once triggered
//           }
//         }
//       });
//     });
  
//     observer.observe(myDiv);
//   } else {
//     console.log('Intersection Observer API is not supported in this browser.');
//   }

//   function loadmoreFuntion() {
  
//      var nextpageurl = jQuery(document).find(".next_page_url").val();
//         if (!nextpageurl) {
//           jQuery('.load_more_btn').hide();
//           return false;
//         }else{
//            jQuery('.loading_btn').show();
//             jQuery('.load-more-div').addClass( 'more-processing' );
  
//             var url = jQuery('.next_page_url').val();
  
//                 jQuery.ajax({
//                     method:'get',
//                     url: location.origin+url,
//                      dataType: 'html',
//                     success: function(result){
//                       var response = jQuery(result).find(".grid-outer #CollectionLoop").html();
//                       var next_page_url = jQuery(result).find(".next_page_url").val();
  
//                       jQuery(".next_page_url").val(next_page_url);
//                       jQuery(".grid-outer #CollectionLoop").append(response);
  
//                       jQuery('.loading_btn').hide();
  
//                       if (!next_page_url) {
//                         jQuery('.load_more_btn').hide();
//                       }
  
//                   },
//                   complete: function(result){
//                         jQuery('.loading_btn').hide();
//                         jQuery('.load-more-div').removeClass( 'more-processing' );
//                   },
//                 });
//           return true;
//         }
//       }
// });


jQuery(document).ready(function(){

  $('footer').attr('id', "footer");

  if ('IntersectionObserver' in window) {
    const myDiv = document.querySelector('#footer');
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          // The div is fully visible in the viewport
          var result = loadmoreFunction();
  
          if (!result) {
            observer.unobserve(entry.target); // Stop observing once triggered
          }
        }
      });
    });
  
    observer.observe(myDiv);
  } else {
    console.log('Intersection Observer API is not supported in this browser.');
  }

  function loadmoreFunction() {
    var nextpageurl = jQuery(document).find(".next_page_url").val();
    if (!nextpageurl) {
      console.log("No next page URL found.");
      jQuery('.load_more_btn').hide();
      return false;
    } else {
      console.log("Loading more content from: " + nextpageurl);
      jQuery('.loading_btn').show();
      jQuery('.load-more-div').addClass('more-processing');

      var url = jQuery('.next_page_url').val();
      console.log("AJAX URL: " + location.origin + url);

      jQuery.ajax({
        method: 'get',
        url: location.origin + url,
        dataType: 'html',
        success: function(result) {
          console.log("AJAX call successful.");
          var response = jQuery(result).find(".grid-outer #CollectionLoop").html();
          var next_page_url = jQuery(result).find(".next_page_url").val();

          console.log("Next page URL: " + next_page_url);
          console.log("Response content: ", response);

          jQuery(".next_page_url").val(next_page_url);
          jQuery(".grid-outer #CollectionLoop").append(response);

          jQuery('.loading_btn').hide();

          if (!next_page_url) {
            jQuery('.load_more_btn').hide();
          }

        },
        complete: function(result) {
          jQuery('.loading_btn').hide();
          jQuery('.load-more-div').removeClass('more-processing');
        },
        error: function(xhr, status, error) {
          console.log("AJAX error: ", error);
        }
      });
      return true;
    }
  }
});